const ContactUsFields = {
  ContactTitle: {
    fieldKey: "ContactTitle",
    element: "select",
    selectList: [
      { constKey: "sales", value: "Sales" },
      { constKey: "upper-SUPPORT", value: "Support" },
      { constKey: "paymants", value: "Payments" },
      { constKey: "suggestions", value: "Suggestions" },
      { constKey: "jumboembed", value: "JUMBOembed" },
      { constKey: "jumbopay", value: "JUMBOpay" },
      { constKey: "sub-users", value: "Sub Users" },
      { constKey: "report-bug", value: "Reporting bugs or security issues" },
      { constKey: "something-else", value: "Something Else" },
    ],
    defaultValue: {
      constKey: "select-topic",
      value: null,
    },
    title: "ContactTitle",
    label: "contact-us-msg",
    placeholder: "contact-us-select-subject",
    validation: {
      required: true,
      invalidMessage: "default-dropdown-invalid-message",
    },
  },
  ContactEmail: {
    fieldKey: "ContactEmail",
    element: "input",
    type: "email",
    title: "ContactEmail",
    label: "contact-us-email",
    placeholder: "contact-us-email",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  },
  ContactSender: {
    fieldKey: "ContactSender",
    element: "input",
    type: "text",
    title: "ContactSender",
    label: "contact-us-name",
    placeholder: "contact-us-name",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
  },
  ContactPhone: {
    fieldKey: "ContactPhone",
    element: "input",
    type: "tel",
    title: "ContactPhone",
    label: "contact-us-phone",
    placeholder: "contact-us-phone",
    validation: {
      required: true,
      reg: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
      invalidMessage: "default-input-invalid-message",
    },
  },
  ContactMessage: {
    fieldKey: "ContactMessage",
    element: "textarea",
    type: "text",
    title: "ContactMessage",
    label: "contact-us-message",
    placeholder: "contact-us-message",
    containerClassName: "input-message-contact",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
  },
};

export default ContactUsFields;
